import React from "react";
import ReactDragListView from "react-drag-listview";

import "./ACColumnDragWrapper.less";

export default function ACColumnDragWrapper({
  children,
  onDragEnd,
}: {
  children: JSX.Element;
  onDragEnd: (fromIndex: number, toIndex: number) => void;
}) {
  return (
    <ReactDragListView.DragColumn
      lineClassName="react-drag-line-override"
      handleSelector=".ac-draggable-column-handle"
      ignoreSelector=".ac-table-selection-column"
      nodeSelector=".ac-draggable-column-th"
      onDragEnd={onDragEnd}
    >
      {children}
    </ReactDragListView.DragColumn>
  );
}
